import React from "react";
import { Router, RouteComponentProps } from "@reach/router";
import { MainLayout } from "ui/Layout/Main";
import { Articles } from "./Articles";
import Presentation from "./Presentation";
import EditArticle from "pages/EditArticle";

const StudentLifePage: React.FC<RouteComponentProps> = () => {

  return (
    <MainLayout>
      <Router>
        <Articles path="/articles" noPageTitle />
        <EditArticle path="/articles/ajouter" section="student_life" />
        <EditArticle path="/articles/editer" section="student_life" />
        <Presentation path="/presentation" noPageTitle />
      </Router>
    </MainLayout>
  );
};

export default StudentLifePage;